module.exports = __webpack_public_path__ + "media/images/products/banners/default_product-201e096ff758f460c9ef9a77fea2cea9.png";